import { upsProblems } from './ups-problems.js'

const breadcrumbParents = {
  "/ups/website-looks-outdated": [{ name: "UPS Digital Connections", href: "/ups" }],
  "/shopify": [{ name: "Ecommerce Web Design", href: "/web-design" }],
  "/bigcommerce": [{ name: "Ecommerce Web Design", href: "/web-design" }],
  "/bigcommerce-to-shopify": [
    { name: "Ecommerce Web Design", href: "/web-design" },
    { name: "Shopify Agency", href: "/shopify" },
  ],
  "/conversion-rate-optimization": [
    { name: "Ecommerce Web Design", href: "/web-design" },
  ],
  "/vip-support": [{ name: "Ecommerce Web Design", href: "/web-design" }],
  "/seo": [{ name: "Ecommerce Web Design", href: "/web-design" }],
  "/ai-optimization": [{ name: "Ecommerce SEO", href: "/seo" }],
  "/ada-accessibility-optimization": [{ name: "Ecommerce SEO", href: "/seo" }],
  "/website-speed-optimization": [{ name: "Ecommerce SEO", href: "/seo" }],
};

const routeNames = {
  ...Object.fromEntries(upsProblems.map((problem) => [problem.path, problem.label])),
  "/ups": "UPS Digital Connections",
  "/ups/website-looks-outdated": "Outdated Website",
  "/shopify": "Shopify Agency",
  "/bigcommerce": "BigCommerce Agency",
  "/bigcommerce-to-shopify": "BigCommerce to Shopify Migration",
  "/conversion-rate-optimization": "Conversion Rate Optimization",
  "/vip-support": "Ecommerce Maintenance and Support",
  "/seo": "Ecommerce SEO",
  "/ai-optimization": "AI Search Optimization",
  "/ada-accessibility-optimization": "ADA Accessibility Optimization",
  "/website-speed-optimization": "Website Speed Optimization",
  "/ecommerce-website-redesign": "Ecommerce Website Redesign",
  "/b2b-ecommerce-agency": "B2B Ecommerce Agency",
  "/shopify-theme-customization": "Shopify Theme Customization",
  "/woocommerce-to-shopify-migration": "WooCommerce to Shopify Migration",
  "/ecommerce-data-migration-services": "Ecommerce Data Migration Services",
  "/shopify-seo": "Shopify SEO",
  "/bigcommerce-seo": "BigCommerce SEO",
  "/ecommerce-seo-audit": "Ecommerce SEO Audit",
  "/google-shopping-management": "Google Shopping Management",
  "/google-merchant-center-services": "Google Merchant Center Services",
  "/klaviyo-email-marketing-agency": "Klaviyo Email Marketing Agency",
  "/mailchimp-to-klaviyo-migration": "Mailchimp to Klaviyo Migration",
  "/ecommerce-website-maintenance": "Ecommerce Website Maintenance",
  "/shopify-support-maintenance": "Shopify Support and Maintenance",
  "/bigcommerce-support-maintenance": "BigCommerce Support and Maintenance",
  "/ecommerce-consulting": "Ecommerce Consulting",
  "/ecommerce-website-audit": "Ecommerce Website Audit",
};

function formatSegment(segment) {
  return segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function getBreadcrumbTrail(path, currentName) {
  const cleanPath = path.split("?")[0].split("#")[0] || "/";
  const trail = [{ name: "Home", href: "/" }];
  const pathSegments = cleanPath.split("/").filter(Boolean);

  if (cleanPath.startsWith("/case-study/")) {
    trail.push({ name: "Case Studies", href: "/case-studies" });
  } else if (cleanPath.startsWith('/ups/')) {
    trail.push({ name: 'UPS Digital Connections', href: '/ups' });
  } else if (breadcrumbParents[cleanPath]) {
    trail.push(...breadcrumbParents[cleanPath]);
  } else if (pathSegments.length > 1) {
    pathSegments.slice(0, -1).forEach((segment, index) => {
      if (segment === "category") return;

      trail.push({
        name: formatSegment(segment),
        href: `/${pathSegments.slice(0, index + 1).join("/")}`,
      });
    });
  }

  if (cleanPath !== "/") {
    const lastSegment = pathSegments.pop();
    trail.push({
      name: currentName || routeNames[cleanPath] || formatSegment(lastSegment),
      href: cleanPath,
    });
  }

  return trail;
}
